import MainFooterBlock from './MainFooterBlock.vue';

export default MainFooterBlock;



// WEBPACK FOOTER //
// ./src/components/parts/modules/modulemain/components/mainfootericonblock/index.ts